var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconDeleteBin = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80617 12.25C3.56311 12.25 3.35652 12.1649 3.18638 11.9948C3.01624 11.8247 2.93117 11.6181 2.93117 11.375V3.0625H2.33325V2.1875H5.07492V1.75H8.92492V2.1875H11.6666V3.0625H11.0687V11.375C11.0687 11.6083 10.9812 11.8125 10.8062 11.9875C10.6312 12.1625 10.427 12.25 10.1937 12.25H3.80617ZM10.1937 3.0625H3.80617V11.375H10.1937V3.0625ZM5.352 10.1208H6.227V4.30208H5.352V10.1208ZM7.77284 10.1208H8.64784V4.30208H7.77284V10.1208Z",
    fill: "#F31F43"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDeleteBin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_delete_bin.05cd315a.svg";
export { ForwardRef as ReactComponent };